module.exports = __webpack_public_path__ + "static/media/register.2a2c976b.jpeg";